import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../../tracking';

const PAGE_HISTORY_MAX_ENTRIES = 300;
const PAGE_HISTORY_UPDATED_EVENT = 'pageHistoryChange';

const HistoryTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location);

    let history = [];
    try {
      const parsed = JSON.parse(localStorage.getItem('pageHistory') || '[]');
      history = Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      history = [];
    }
    const pathWithSearch = `${location.pathname}${location.search || ''}`;
    const newEntry = {
      path: pathWithSearch,
      timestamp: new Date().toISOString(),
    };

    // Optional: Prevent consecutive duplicates
    if (history[history.length - 1]?.path !== newEntry.path) {
      const nextHistory = [...history, newEntry].slice(-PAGE_HISTORY_MAX_ENTRIES);
      localStorage.setItem('pageHistory', JSON.stringify(nextHistory));
      window.dispatchEvent(new Event(PAGE_HISTORY_UPDATED_EVENT));
    }
  }, [location]);

  return null; // this component renders nothing
};

export default HistoryTracker;
